export default "__VITE_ASSET__BeUOfXCv__"